import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Typography } from '@mui/material';
import Button from '@shared/components/Buttons/Button';
import DynamicIcon, { IconName } from '@shared/components/Icon';
import { theme } from '@shared/theme';
import React from 'react';

interface SectionHeaderReaderProps {
  headerSubtext: string;
  scrollToTop: () => void;
  iconName?: IconName;
  canEdit?: boolean;
  isEditMode?: boolean;
  onToggleEditMode?: () => void;
  sectionKey?: string;
  scrollToSection?: (key?: string) => void;
}

function SectionHeaderReader(props: SectionHeaderReaderProps) {
  const { headerSubtext, scrollToTop, iconName, canEdit, isEditMode, onToggleEditMode, sectionKey, scrollToSection } =
    props;

  return (
    <Box
      sx={{
        backgroundColor: '#0b74da',
        color: '#ffffff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(2),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: theme.spacing(0.5),
        }}
      >
        <DynamicIcon iconName={iconName || IconName.Business} />{' '}
        <Typography
          sx={{
            fontWeight: 'bold',
            color: '#ffffff',
            fontSize: '1.4rem',
            [theme.breakpoints.down('md')]: {
              fontSize: '1.2rem',
            },
          }}
        >
          {headerSubtext}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {canEdit && (
          <Button
            size="small"
            whiteTheme
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onToggleEditMode?.();
              setTimeout(() => {
                scrollToSection?.(sectionKey);
              }, 100);
            }}
            startIcon={isEditMode ? <VisibilityIcon sx={{ fontSize: 18 }} /> : <EditIcon sx={{ fontSize: 18 }} />}
          >
            {isEditMode ? 'View' : 'Edit'}
          </Button>
        )}
        <Button size="small" whiteTheme onClick={scrollToTop}>
          Back to Top
        </Button>
      </Box>
    </Box>
  );
}

export default SectionHeaderReader;
